/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Sep-30
 *
 **/

//import router from "./../router"; @TODO
import {Auth} from "../api";
import {loginResponseModel, loginRequestModel} from "./../api/models";
import {createTimeWithIncrement, isDateExpired, toFormData} from "./../core/utils";
import Constants from "./../core/constants";
import {createStrongPassword} from "../core/utils";
import * as Storage from './../core/storage.js'
import verifyPhoneRequest from "../api/models/register/verify-phone.request";
import confirmPhoneRequest from "../api/models/register/confirm-phone.request";
import moment from "moment";

const accountModule =  {
    namespaced: true,
    state: {
        loggedIn: false,
        user: null,
        authentication: loginResponseModel(),

        googleUserData: null,
        googleRegisterRequested: false,

        FB: null,
        facebookUserData: null,
        facebookRegisterRequested: false,
        facebookLoginData: null,

        googleOrFBLoginData: null,
        isAuthenticating: false,

        emailOrUsernameValid: false,
        userHasTryAvailable: null,

        isJustProfileUpdated: false,

        verificationPhoneData: null,
        confirmPhoneSuccess: false,

        searchCurpResult: null
    },
    getters: {
        isGuestUser: state =>{
            return state.user.usuario === 'invitado'
        }
    },
    actions: {
        login({commit, dispatch}, request = loginRequestModel) {
            dispatch('alerts/showLoading', 'Authenticando el usuario', {root: true})
            commit('logout')
            Auth.postLogin(toFormData(request))
                .then(data => {
                    commit('loginSuccess', data)

                    if (request.username === 'invitado'){
                        commit('setSessionGuest', data.access_token)
                    }

                    dispatch('alerts/hideLoading', null, {root: true})
                    dispatch('getUserProfile', null)
                })
                .catch(error => {
                    dispatch('alerts/hideLoading', null, {root: true})
                    dispatch('alerts/error', error.code === 401 ? 'Usuario/contraseña es incorrecta': error.message, {root: true})
                })
        },

        loginOrRegisterWithGoogle({commit, dispatch}, userData){
            dispatch('alerts/showLoading', 'Validando email ...', {root: true})
            Auth.postValidateGoogleCredentials(userData.id, userData.email)
                .then(data => {
                    if (data.account_exists){
                        let request = loginRequestModel()
                        request.username = userData.id
                        request.password = createStrongPassword(userData.id, userData.email)
                        dispatch('login', request )
                    }
                    else {
                        dispatch('alerts/hideLoading', null, {root: true})
                        dispatch('alerts/success', 'Completa los siguientes datos para continuar con el registro', {root: true})
                        commit('requestRegisterWithGoogle', userData)
                        //router.push('register') @TODO
                        dispatch('alerts/redirect', {name:'register'}, {root: true})

                    }
                })
                .catch(error => {
                    dispatch('alerts/hideLoading', null, {root: true})
                    dispatch('alerts/error', error.message, {root: true})
                })
        },

        loginOrRegisterWithFacebook({commit, dispatch}, userData){
            dispatch('alerts/showLoading', 'Validando cuenta de facebook ...', {root: true})
            Auth.postValidateFacebookCredentials(userData.id, userData.email)
                .then(data => {
                    if (data.account_exists){
                        let request = loginRequestModel()
                        request.username = userData.id
                        request.password = createStrongPassword(userData.id, userData.id)
                        dispatch('login', request )
                    }
                    else {
                        dispatch('alerts/hideLoading', null, {root: true})
                        dispatch('alerts/success', 'Completa los siguientes datos para continuar con el registro', {root: true})
                        commit('requestRegisterWithFacebook', userData)
                        //router.push('register') //@TODO
                        dispatch('alerts/redirect', {name:'register'}, {root: true})
                    }
                })
                .catch(error => {
                    dispatch('alerts/hideLoading', null, {root: true})
                    dispatch('alerts/error', error.message, {root: true})
                })
        },

        logout({commit, dispatch}){
            commit('logout')
            //router.push({name:'login'}) //@TODO
            dispatch('alerts/redirect', {name:'login'}, {root: true})
        },

        /**
         * @param commit
         * @param request type of registerRequest
         */
        registerUser({commit, dispatch}, requestModel){
            dispatch('alerts/showLoading', 'Registrando los datos del nuevo usuario ...', { root: true })
            Auth.postRegister(toFormData(requestModel))
                .then(data => {
                    dispatch('alerts/success', `El usuario "${data.data.usuario}" fue creado correctamente`,  { root: true })
                    commit('registerUserSuccess', data.data)
                    //router.push('login') @TODO
                    dispatch('alerts/redirect', {name:'login'}, {root: true})
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async checkAuthExpiration({commit, dispatch, state}){
            if (!state.isAuthenticating){
                let expirationTime = parseInt(Storage.getItem(Constants.KEY_TOKEN_EXPIRATION))
                if (isDateExpired(expirationTime))
                {
                    let authentication = Storage.getItem(Constants.KEY_AUTHENTICATION)
                    if (!authentication){
                        return dispatch('logout', null)
                    }

                    let authObject = JSON.parse(authentication)
                    Storage.removeItem(Constants.KEY_TOKEN)

                    try {
                        state.isAuthenticating = true

                        let authData = await Auth.postRefreshLogin(authObject.refresh_token)
                        commit('loginSuccess', authData)
                        await dispatch('getUserProfile', null)

                    }catch (ex){
                        dispatch('alerts/error', 'Su sesión ha expirado, inicia nuevamente.',  { root: true })
                        dispatch('logout', null)
                    }

                    state.isAuthenticating = false
                }
            }else {
                let promise = new Promise((res) => {
                    setTimeout(() => res(true), 200)
                })

                await promise

                if (state.isAuthenticating){
                    await dispatch('account/checkAuthExpiration', null,  { root: true })
                }
            }
        },

        checkLogin({commit, dispatch}){
            let token = Storage.getItem(Constants.KEY_TOKEN)
            let user = Storage.getItem(Constants.KEY_USER)
            let authenticationString = Storage.getItem(Constants.KEY_AUTHENTICATION)

            if (token && authenticationString && user){
                commit('hasAuthentication', JSON.parse(user), JSON.parse(authenticationString));
            }else{
                let currentRoute = window.location.pathname
                if (!currentRoute.includes('register') && !currentRoute.includes('forgot_password')
                    && !currentRoute.includes('documents/validate') && !currentRoute.includes('requirements')  && !currentRoute === '/' ) {
                    //router.push('login'); @TODO
                    dispatch('alerts/redirect', {name:'login'}, {root: true})
                }
            }
        },

        getUserProfile({commit, dispatch}){
            dispatch('alerts/showLoading', 'Obteniendo información del usuario ...', { root: true })
            Auth.getUserProfile()
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('userProfileSuccess', data.data)

                    /*if (router.currentRoute.name === 'login'){  @TODO
                        router.push('/')  @TODO
                    }*/
                    dispatch('alerts/redirect', {name:'home', validator: 'login'}, {root: true})

                })
                .catch(error => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    console.log(error)
                })
        },

        cancelRegisterWitGoogleOrFacebook({commit, dispatch}){
            commit('cancelRegisterWithGoogleOrFacebook')
            //router.push('login') @TODO
            dispatch('alerts/redirect', {name:'login'}, {root: true})
        },

        saveFacebookSession({commit}, FB){
            commit('saveFacebookSession', FB)
        },

        // eslint-disable-next-line no-unused-vars
        async postUserProfile({commit, dispatch}, userData){
            dispatch('alerts/showLoading', 'Actualizando información del usuario', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Auth.updateProfile(toFormData(userData))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('alerts/success', "Información del usuario actualizado correctamente.",  { root: true })

                    commit('userProfileSuccess', data.data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                    console.log(error)
                })
        },

        async changeAccountPassword({dispatch}, data){
            dispatch('alerts/showLoading', 'Actualizando la contraseña de la cuenta', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Auth.updatePassword(toFormData(data))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('alerts/success', data.message,  { root: true })
                    //router.push({name: 'home'}) @TODO
                    dispatch('alerts/redirect', {name:'home'}, {root: true})
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async requestForgotPassword({dispatch}, request){
            dispatch('alerts/showLoading', 'Validando los datos para mandar email', { root: true })

            Auth.forgotPasswordRequest(toFormData(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('alerts/success', data.message,  { root: true })
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async setNewUserPassword({dispatch}, request){
            dispatch('alerts/showLoading', 'Registrando tu nueva contraseña', { root: true })

            Auth.newPassword(toFormData(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('alerts/success', data.message,  { root: true })
                    //router.push({name: 'login'}) @TODO
                    dispatch('alerts/redirect', {name:'login'}, {root: true})
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async validateEmailAndUsername({dispatch, commit}, request) {
            dispatch('alerts/showLoading', 'Validando usuario y email.', {root: true})

            Auth.postValidateUniqueCredentials(toFormData(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, {root: true})

                    commit('setValidationUsernameEmail', data)
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    dispatch('alerts/error', error.message, {root: true})
                })
        },


        async resendVerificationCode({dispatch}, request){
            dispatch('alerts/showLoading', 'Enviando código de verificación.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })
            console.log(request);
            Auth.sendVerificationCode(request)
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('alerts/success', data.message,  { root: true })
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async verifyUserCode({dispatch}, request){
            dispatch('alerts/showLoading', 'Verificando la nueva cuenta.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Auth.verifyRegister(toFormData(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    dispatch('alerts/success', data.message,  { root: true })

                    dispatch('getUserProfile', null)
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        async getTryAvailable({dispatch, commit}){
            dispatch('alerts/showLoading', 'Obteniendo información de la cuenta.', { root: true })
            await dispatch('account/checkAuthExpiration', null, { root: true })

            Auth.verifyTryAvailable()
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })
                    commit('setUserHasTrayAvailable', data.tryAvailable)
                })
                .catch(error => {
                    console.log(JSON.stringify(error))
                    commit('setUserHasTrayAvailable', true)
                })
        },

        verifyPhone({dispatch, commit}, request = verifyPhoneRequest()){
            dispatch('alerts/showLoading', 'Verificando el número telefónico.', { root: true })

            Auth.verifyPhoneNumber(toFormData(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })

                    if (data.success){
                        commit('setVerificationPhoneRequest', data.data)
                    }else{
                        dispatch('alerts/error', "Hubo un error al intentar validar el número de teléfono. Intenta nuevamente",  { root: true })
                    }
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        confirmPhone({dispatch, commit}, request = confirmPhoneRequest()){
            dispatch('alerts/showLoading', 'Enviando código de verificación recibido por sms.', { root: true })

            Auth.confirmPhoneNumber(toFormData(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })

                    if (data.success){
                        commit('setConfirmPhoneSuccess', data.data)
                    }else{
                        dispatch('alerts/error', data.message,  { root: true })
                    }
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        },

        searchCurpByName({dispatch, commit}, request){
            dispatch('alerts/showLoading', 'Buscando CURP con los datos de ciudadano.', { root: true })

            Auth.searchCurpByName(toFormData(request))
                .then(data => {
                    dispatch('alerts/hideLoading', null, { root: true })

                    if (data.status !== undefined && data.status === 'ok'){
                        let years = moment().diff(moment(data.data.fechaNac, 'DD/MM/YYYY'), 'years')
                        console.log(years)

                        if (years >= 18){
                            commit('setSearchCurpResult', data.data)
                        }else{
                            dispatch('alerts/error', 'La CURP es de un menor de edad, no es admitido',  { root: true })
                        }
                    }else{
                        dispatch('alerts/error', 'No se pudo obtener la CURP con los datos proporcionados',  { root: true })
                    }
                })
                .catch(error => {
                    dispatch('alerts/error', error.message,  { root: true })
                })
        }
    },
    mutations: {
        loginRequest(state){
            state.loggedIn = false
            state.user = null
        },

        loginSuccess(state, data){
            Storage.setItem(Constants.KEY_TOKEN, data.access_token)
            Storage.setItem(Constants.KEY_TOKEN_EXPIRATION, createTimeWithIncrement(data.expires_in).toString())
            Storage.setItem(Constants.KEY_AUTHENTICATION, JSON.stringify(data))

            state.loggedIn = true
            state.authentication = data

            state.googleOrFBLoginData = null
        },

        hasAuthentication(state, user, authentication){
            state.loggedIn = true
            state.user = user
            state.authentication = authentication
        },

        logout(state){
            Storage.removeItem(Constants.KEY_AUTHENTICATION)
            Storage.removeItem(Constants.KEY_TOKEN)
            Storage.removeItem(Constants.KEY_USER)
            Storage.removeItem(Constants.KEY_TOKEN_EXPIRATION)
            Storage.removeItem(Constants.KEY_TOKEN_GUEST)

            Storage.removeItem(Constants.KEY_LAST_FORM_URL)
            Storage.removeItem(Constants.KEY_LAST_PROCESS_EXECUTED)
            Storage.removeItem(Constants.KEY_SKIP_VERIFICATION_CODE)
            Storage.removeItem(Constants.KEY_LAST_FISCAL_CONTACT)

            Storage.removeItem(Constants.KEY_SKIP_VERIFICATION_CODE)

            state.loggedIn = false
            state.authentication = loginRequestModel()
            state.user = null
        },

        userProfileSuccess(state, data){
            Storage.setItem(Constants.KEY_USER, JSON.stringify(data))
            state.user = data
            state.isJustProfileUpdated = true
        },

        requestRegisterWithGoogle(state, userData){
            state.googleRegisterRequested = true
            state.googleUserData = userData
        },

        requestRegisterWithFacebook(state, userData){
            state.facebookRegisterRequested = true
            state.facebookUserData = userData
        },

        registerUserSuccess(state, userRegistered){
            if (state.googleRegisterRequested || state.facebookRegisterRequested)
            {
                state.googleOrFBLoginData = loginRequestModel()
                state.googleOrFBLoginData.username =  userRegistered.usuario
                state.googleOrFBLoginData.password =  createStrongPassword(
                    userRegistered.usuario,
                    state.googleRegisterRequested ? userRegistered.email : userRegistered.usuario)

                state.googleRegisterRequested = false
                state.googleUserData = null

                state.facebookRegisterRequested = false
                state.facebookUserData = null
            }
        },

        cancelRegisterWithGoogleOrFacebook(state){
            state.googleRegisterRequested = false
            state.googleUserData = null

            state.facebookRegisterRequested = false
            state.facebookUserData = null
        },

        saveFacebookSession(state, FB){
            state.FB = FB
        },

        setSessionGuest(state, sessionToken){
            Storage.setItem(Constants.KEY_TOKEN_GUEST, sessionToken)
        },

        setValidationUsernameEmail(state) {
            state.emailOrUsernameValid = true
        },

        setUserHasTrayAvailable(state, hasTryAvailable){
            state.userHasTryAvailable = hasTryAvailable
        },

        setVerificationPhoneRequest(state, verificationRequestResult){
            state.verificationPhoneData = verificationRequestResult
        },

        setConfirmPhoneSuccess(state, confirmPhoneSuccess){
            state.confirmPhoneSuccess = confirmPhoneSuccess
        },

        setSearchCurpResult(state, curpResult){
            state.searchCurpResult = curpResult
        }
    },
}

export default accountModule